import { render } from "./RunoffSequenceMenu.vue?vue&type=template&id=33d6581c&scoped=true"
const script = {}

import "./RunoffSequenceMenu.vue?vue&type=style&index=0&id=33d6581c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6581c"]])

export default __exports__